import { CustomerPortalProductOption } from '@shared/models/product/product-filter.model';
import { CustomerAddressProductLookup } from '@shared/models/customer-address/customer-address.model';

export interface ProductSelectOption {
  label: string;
  value: string;
}

export function mapProductLookup(
  products: CustomerAddressProductLookup[]
): CustomerPortalProductOption[] {
  return products.map((product) => ({
    productId: product.id,
    name: product.name,
    productCode: product.code,
    status: 'ACTIVE',
    type: '',
  }));
}

export function filterActiveProducts(
  productList: CustomerPortalProductOption[]
): CustomerPortalProductOption[] {
  return productList.filter((product) => product.status === 'ACTIVE');
}

export function mapActiveProductOptions(
  productList: CustomerPortalProductOption[]
): ProductSelectOption[] {
  return filterActiveProducts(productList).map((product) => ({
    label: product.name,
    value: String(product.productId),
  }));
}

export function buildProductOptionsWithAll(
  productList: CustomerPortalProductOption[],
  allProductsLabel: string
): ProductSelectOption[] {
  return [
    { label: allProductsLabel, value: '' },
    ...mapActiveProductOptions(productList),
  ];
}
